import { enLayout } from '../en';
import { frLayout } from '../fr';
import { esLayout } from '../es';
import { deLayout } from '../de';

export const layoutModuleTranslations = {
  en: enLayout,
  fr: frLayout,
  es: esLayout,
  de: deLayout,
} as const;

